import Vue from 'vue'
import Router from 'vue-router'
import Home from "@/views/Home.vue";
import AppHeader from "@/layout/AppHeader";
import AppFooter from "@/layout/AppFooter";
import Article from "@/views/Article.vue";
import About from "@/views/About.vue";
import Faq from "@/views/Faq.vue";
import Contact from "@/views/Contact.vue";

Vue.use(Router)

export default new Router({
    mode: "history",
    base: process.env.ROUTER_BASE,
    routes: [
        { path: '/', redirect: '/home' },
        {
            path: '/home',
            name: 'home',
            components: {
                header: AppHeader,
                default: Home,
                footer: AppFooter
            }
        },
        {
            path: "/article/:slug",
            name: "article",
            components: {
                header: AppHeader,
                default: Article,
                footer: AppFooter
            }
        },
        {
            path: "/about",
            name: "about",
            components: {
                header: AppHeader,
                default: About,
                footer: AppFooter
            }
        },
        {
            path: "/faq",
            name: "faq",
            components: {
                header: AppHeader,
                default: Faq,
                footer: AppFooter
            }
        },
        {
            path: "/contact",
            name: "contact",
            components: {
                header: AppHeader,
                default: Contact,
                footer: AppFooter
            }
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js